import { render } from "./ListGroup.vue?vue&type=template&id=64ed8dcc"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"
script.render = render

export default script